var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBloodtype(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.82 92.34",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Blood_type_svg__cls-1{fill:#878789}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Blood_type_svg__cls-1",
    d: "M28.68 0h1.44a4.37 4.37 0 012.57 2.09c3.54 6.62 7.2 13.17 10.66 19.83A209.54 209.54 0 0156.5 51.69a37.76 37.76 0 012.28 10A28.24 28.24 0 0154 79.07a28.72 28.72 0 01-16.59 12.1 35.82 35.82 0 01-6.16 1.13 22.78 22.78 0 01-3.54-.08 5.28 5.28 0 01-.59 0 27.82 27.82 0 01-17.79-7.89C1.12 76.29-1.9 66.67 1.18 55.4a120.49 120.49 0 016.67-17.76c5.37-12 11.52-23.56 17.94-35A4.86 4.86 0 0128.68 0zm.71 9.75c-.18.29-.31.48-.42.69-4.16 8.08-8.4 16.12-12.44 24.27A145.15 145.15 0 008 55.38a25.18 25.18 0 00-1.53 8.36 22.33 22.33 0 006.29 15.18 22 22 0 0019.2 7c8.64-1 14.86-5.7 18.5-13.6A19.74 19.74 0 0052 60.08a74.76 74.76 0 00-4.88-14.6 388.89 388.89 0 00-17.29-35c-.09-.2-.24-.42-.44-.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Blood_type_svg__cls-1",
    d: "M45 63.64a15.56 15.56 0 01-15.23 14.8A3.46 3.46 0 0126 75.25a3.35 3.35 0 013.32-3.69 9.91 9.91 0 005.22-1.73 8.85 8.85 0 003.57-6.95 3.44 3.44 0 014.24-3.36c1.74.37 2.74 1.92 2.65 4.12z"
  })))));
}

export default SvgBloodtype;